<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0"></dialogos-app>
            </v-flex>
        </v-layout>
        <v-layout wrap row justify-center align-center class="cont_page animated fadeIn dura-1">
          <v-flex xs11 sm7 md7 mb-2 text-xs-center>
                <div class="item-btn-modal btn-blue-light hvr hvr" :class="{'btnexpandvisto':vistosExpand[0]}" @click="expandAction(0)">
                    <span>1</span>
                    <v-icon class="icon" size="30" color="#0067AD" :class="{'icon-active':expand[0]}">navigate_next</v-icon>
                </div>
                <v-expand-transition>
                  <div class="cont-item-modal" v-show="expand[0]">
                    <ul>
                      <li>Sim.</li>
                      <li>Não.</li>
                      <li>Por favor.</li>
                      <li>O senhor poderia <span class="btn-tool hvr" @click="toolAction(5)">soletrar?</span></li>
                      <li><span class="btn-tool hvr" @click="toolAction(0)">Pois não</span></li>
                      <li>Obrigado (homens).</li>
                      <li>Obrigada (mulheres).</li>
                      <li>De nada.</li>
                      <li><span class="btn-tool hvr" @click="toolAction(1)">Pronto?</span></li>
                    </ul>
                  </div>
                </v-expand-transition>
          </v-flex>
          <v-flex xs11 sm7 md7 mb-2 text-xs-center>
                <div class="item-btn-modal btn-blue-light hvr hvr" :class="{'btnexpandvisto':vistosExpand[1]}" @click="expandAction(1)">
                    <span>2</span>
                    <v-icon class="icon" size="30" color="#0067AD" :class="{'icon-active':expand[1]}">navigate_next</v-icon>
                </div>
                <v-expand-transition>
                  <div class="cont-item-modal" v-show="expand[1]">
                    <ul>
                      <li><span class="btn-tool hvr" @click="toolAction(2)">Né?</span> / Tá.</li>
                      <li><span class="btn-tool hvr" @click="toolAction(3)">Cadê?</span></li>
                      <li>Como se diz? </li>
                      <li>Como se pronuncia? </li>
                      <li>Você poderia repetir? </li>
                      <li>Você poderia soletrar? </li>
                      <li>Como se escreve...?</li>
                      <li>Por favor, fale mais <span class="btn-tool hvr" @click="toolAction(4)">devagar.</span></li>
                    </ul>
                  </div>
                </v-expand-transition>
          </v-flex>
          <v-flex xs11 sm7 md7 mb-2 text-xs-center>
                <div class="item-btn-modal btn-blue-light hvr hvr" :class="{'btnexpandvisto':vistosExpand[2]}" @click="expandAction(2)">
                    <span>3</span>
                    <v-icon class="icon" size="30" color="#0067AD" :class="{'icon-active':expand[2]}">navigate_next</v-icon>
                </div>
                <v-expand-transition>
                  <div class="cont-item-modal" v-show="expand[2]">
                    <ul>
                      <li>Eu tenho uma dúvida.</li>
                      <li>Com licença.</li>
                      <li>Desculpe.</li>
                    </ul>
                  </div>
                </v-expand-transition>
          </v-flex>
          <v-flex xs11 sm7 md7 mb-2 text-xs-center mt-3>
            <button @click="openModal()" class="button-lectura" :class="{'btnexpandvisto':book}">
              <img src="@/assets/imagenes_compartidas/lectura.svg" alt="">
            </button>
          </v-flex>
        </v-layout>

        <!-- modal tool contenido -->
        <modal-app v-model="modalB" :fullscreen="false" width="700px">
            <template slot="modaltittle">
              <h1 class="modal-icon-title-tool">{{modalToolTitulo[toolNum]}}</h1>
            </template>
            <v-layout row wrap>
              <v-flex xs12 md12>
              <p>{{modalToolText[toolNum]}}</p>
              </v-flex>
            </v-layout>
        </modal-app>
        <!-- modal para primer contenido -->
        <modal-app v-model="modal" :fullscreen="true" heightCerrar="100px" :mostrarCerrar="verCerrar" @click="modalAction()" @pausarAudio="pausarAudio(0)">
            <template slot="modaltittle">
                <span class="modal-icon-title">
                    <button class="btn-blue-dark" @click="$refs.audioPlayer.playAudio(0)">
                      <span>Clique para escutar <v-icon color="white">headset</v-icon></span>
                    </button>
                </span>
            </template>
            <v-layout row wrap>
              <v-flex xs12 md12>
              <modalslide1 @todosVistosSlide="mostrarcerrarmodal()"></modalslide1>
              </v-flex>
            </v-layout>
        </modal-app>
        <audio-player ref="audioPlayer" :autoplay="false" :audios="['Lecturas/Dialogo com as expressoes cotidianas']"></audio-player>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import modalslide1 from '@/pages/unidad1/slide-mod11/modalslide1';

export default {
    components: {
      modalslide1,
    },
  mixins: [nextConditions],
  data() {
    return {
      dialogos: [
        'Conheça algumas expressões cotidianas e veja como são usadas.',
        'Depois, clique no ícone do livro.'
      ],
      modal:false,
      modalB:false,
      expand: false,
      expandB: false,
      expandC: false,
      verCerrar: false,
      modalToolText:[
        'Uma maneira cortês de responder "sim", "claro".',
        'Quer dizer estar disposto, desimpedido ("Estou pronto para ajudá-lo.").',
        'É uma contração de "Não é?"',
        'Significa "onde está?"',
        'É o contrário de rápido.',
        'É falar letra por letra.',
      ],
      modalToolTitulo:[
        'Pois não.',
        'Pronto',
        'Né?',
        'Cadê?',
        'Devagar',
        'Soletrar'
      ],
      toolNum:0,
      book:false,
      vistosExpand:Array(3).fill(false),
      expand:Array(3).fill(false)
    }
  },
  methods: {
    openModal(){
      this.modal = true
      this.book = true
    },
    mostrarcerrarmodal(){
      this.verCerrar = true
    },
    modalAction(){
      this.$store.commit('nextShow', true);
    },
    toolAction(val){
      this.toolNum = val
      this.modalB = true
    },
    expandAction(val){
      var position = this.expand[val]
      console.log(position)
      if(position === false){
        this.$set(this.expand,val,true)
        this.$set(this.vistosExpand,val,true)
        console.log(this.expand)
      }else{
        this.$set(this.expand,val,false)
      }
    },
    pausarAudio(){
      console.log("audio pausado")
      this.$refs.audioPlayer.pauseAudio(0)
    }
  },
  watch: {

  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';
ul{
  list-style: none;
  text-align: left;
  font-family: Poppins-Regular;
  font-size: 13px;
  margin: 0;
  padding: 0;
    li{
        list-style: none;
        margin: 0;
        padding: 0;
    }
}
.item-btn-modal{
    color: #0067AD;
    border-radius: 4px 4px 0px 0px;
    .icon{
    float:right;
    transition: all 0.3s ease-out;
    transform: rotate(0deg);
    }
    span{
        font-family: Poppins-Bold;
        color: black;
    }
}
.icon-active{
    transform: rotate(90deg)!important;
}
.cont-item-modal{
    padding: 5px 0px;
    transition:all 0.4s ease-out;
    padding: 10px;
    outline: none;
    border-radius: 0px 0px 4px 4px;
    border: solid #81C7FD 2px;
}
.cont-visto{
    display: block;
}
.li-btn-green{
    background: #5A8B34;
    width: auto;
    padding: 5px 10px;
    border-radius: 4px;
    color: white;
}
.li-btn-orange{
    background: #CD4036;
    width: auto;
    padding: 5px 10px;
    border-radius: 4px;
    color: white;
}
.button-lectura{
  img{
    width: 100px;
  }
}
.modal-icon-title-tool{
  margin: 0;
  padding: 0;
  height: auto;
  font-size: 20px;
  font-family: 'Poppins-Regular';
  line-height: 1em;
  text-align: center;
  margin: 0 auto;
  color: $ibra-dark-blue;
}
.btn-tool{
  color: $ibra-dark-blue;
  font-family: 'Poppins-Bold';
}
</style>
